<template>
  <div id="checkout-denied" :class="{ mobile: isMobile(), isIcon: icon === 'sad-bag.svg' }">
    <AssetV3
      :style="icon === 'sad-bag.svg' ? 'width: 48px; height: 48px;' : 'width: 160px;'"
      :dir="icon === 'sad-bag.svg' ? 'abstract' : 'icons'"
      :name="icon"
    />

    <div class="checkout-denied-title"
      :class="{ mobile: isMobile(), isIcon: icon === 'sad-bag.svg'}">
      <h3>{{ titleDeniedMessage }}</h3>
    </div>

    <div class="checkout-denied-info"
      :class="{ mobile: isMobile() }">
      <span v-html="infoDeniedMessage"></span>
    </div>

    <div class="checkout-denied-button" :class="{ mobile: isMobile() }">
      <button class="primary outline button-link" @click="goTo(checkoutUrl)">
        Voltar para a loja
      </button>
    </div>

  </div>
</template>

<script>
import { mapActions, mapState, mapGetters } from 'vuex';
import AssetV3 from '@/components/common/AssetV3.vue';
import UtilMixing from '@/mixins/util';

export default {
  name: 'checkout-denied',
  mixins: [UtilMixing],
  data: () => ({
    assetData: [{
      assetName: 'denied.svg',
    }],
  }),
  computed: {
    ...mapState('checkoutRedirect', [
      'checkoutUrl',
      'hasPreCondition',
      'options',
    ]),
    ...mapGetters('checkoutRedirect', [
      'titleDeniedMessage',
      'infoDeniedMessage',
    ]),
    icon() {
      return 'sad-bag.svg';
    },
  },
  methods: {
    ...mapActions('checkoutRedirect', [
      'emitEvent',
    ]),
    goTo(to) {
      window.location.href = to;
    },
  },
  mounted() {
    if (this.hasPreCondition) {
      this.emitEvent({
        type: 'predenied',
      });
    } else {
      this.emitEvent({
        type: 'denied',
      });
    }
  },
  components: {
    AssetV3,
  },
};
</script>

<style lang="scss" scoped>
#checkout-denied {
  text-align: center;
  padding-left: 20px;
  padding-right: 20px;
  color: #212B36;
  &.isIcon {
    text-align: left;
    padding: 0px;
    margin-top: 5px;
  }
  &.mobile {
    padding-left: 24px;
    padding-right: 24px;
  }
}
.checkout-denied-title {
  padding-top: 24.18px;
  font-style: normal;
  font-weight: 700;
  font-size: 24px;
  line-height: 32px;
  &.isIcon {
    padding-top: 16px;
  }
  &.mobile {
    text-align: left;
  }
}
.checkout-denied-info {
  font-weight: 400;
  padding-top: 16px;
  line-height: 28px;
  font-size: 16px;

  &.mobile {
    text-align: left;
    font-size: 18px;
  }
}

.checkout-denied-button {
  padding-top: 16px;
}
</style>
